module.exports = __webpack_public_path__ + "static/media/burger-kale-carousel.e4f0f5a0.jpg";